export default __webpack_public_path__ + "images/bigship_vasControl.svg";